module.exports = __webpack_public_path__ + "static/media/edfinanciera.bf3152fd.png";